import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import {
  InsuranceAddressNumberField,
  InsuranceAgentField,
  InsuranceCompanyField,
  InsuranceCoverageAmountField,
  InsuranceEffectiveDateField,
  InsuranceExperienceDateField,
  InsuranceIsOnFileWithStateField,
  InsurancePhoneNumberField,
  InsurancePolicyNumberField,
} from '@src/permitTypesManager/permitTypeSections/PermitInsuranceFields';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PermitInsuranceSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();

  const fields: SectionField[] = [
    {
      field: InsuranceCompanyField,
      label: t('fields.insuranceCompany'),
    },
    {
      field: InsuranceEffectiveDateField,
      label: t('fields.insuranceEffectiveDate'),
    },
    {
      field: InsuranceExperienceDateField,
      label: t('fields.insuranceExperienceDate'),
    },
    {
      field: InsuranceCoverageAmountField,
      label: t('fields.insuranceCoverageAmount'),
    },
    {
      field: InsurancePolicyNumberField,
      label: t('fields.insurancePolicyNumber'),
    },
    {
      field: InsuranceAgentField,
      label: t('fields.insuranceAgentAmount'),
    },
    {
      field: InsurancePhoneNumberField,
      label: t('fields.insurancePhoneNumber'),
    },
    {
      field: InsuranceAddressNumberField,
      label: t('fields.insuranceAddressNumber'),
    },
    {
      field: InsuranceIsOnFileWithStateField,
      label: t('fields.insuranceIsOnFileWithState'),
    },
  ];

  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList sectionFields={fields} control={control} />
    </Stack>
  );
};
